<script>
	import SortButton from "src/components/SortButton/SortButton.svelte";
	import { navigate } from "svelte-routing";
	import {
		Dropdown,
		DropdownItem,
		DropdownMenu,
		DropdownToggle,
		Table,
	} from "@sveltestrap/sveltestrap";
	import Pagination from "../../../components/CustomPaginate/Pagination.svelte";
	import LoaderContainer from "../../../components/Loader/LoaderContainer.svelte";
	import { servicingStatus } from "../../../utils/options";
	export let data;
	export let handleSort;

	let sort = {
		desc: "desc",
		column: "",
	};

	let isDropdownOpen = -1; // Tracks the state of the dropdown (open/close)
	let canToggleDropdown = false; // Your condition for whether the dropdown can open

	function toggleDropdown(jobs, index) {
		if (jobs.length > 2 && index !== isDropdownOpen) {
			isDropdownOpen = index;
		} else {
			isDropdownOpen = -1;
		}
	}

	function checkDueDate(days) {
		const daysAway = Math.abs(days);
		const isPastDue = days < 0;

		if (daysAway === 0) {
			return `<span>Today</span>`;
		}

		const daysText = `${daysAway} day${daysAway === 1 ? "" : "s"}`;
		return `<span${isPastDue ? ' style="color: red;"' : ""}>${daysText} ${
			isPastDue ? "ago" : "away"
		}</span>`;
	}

	function checkMileage(mileage) {
		if (mileage === null) {
			return `<span>NULL</span>`;
		}
		const formattedMileage = new Intl.NumberFormat("en-US").format(mileage);
		return `<span${
			mileage <= 0 ? ' style="color: red;"' : ""
		}>${formattedMileage} km</span>`;
	}

	function toggleSort(column) {
		if (sort.column === column) {
			sort.desc = sort.desc === "desc" ? "asc" : "desc";
		} else {
			sort.column = column;
			sort.desc = "asc";
		}
		handleSort(column, sort.desc);
	}
</script>

<LoaderContainer>
	<Table responsive hover>
		<thead>
			<tr>
				<th>
					<span class="sort-column">
						Carplate No.
						<SortButton {sort} {toggleSort} column="plateNumber" />
					</span>
				</th>
				<th>
					<span class="sort-column">
						Carpark ID
						<SortButton {sort} {toggleSort} column="carParkName" />
					</span>
				</th>
				<th>Region</th>
				<th>
					<span class="sort-column">
						Status
						<SortButton {sort} {toggleSort} column="status" />
					</span>
				</th>
				<th>
					<span class="sort-column">
						Due date
						<SortButton
							{sort}
							{toggleSort}
							column="numberOfDaysToDueDate"
						/>
					</span>
				</th>
				<th>
					<span class="sort-column">
						Mileage left
						<SortButton
							{sort}
							{toggleSort}
							column="mileageLeftInKm"
						/>
					</span>
				</th>
				<th>Job ID</th>
			</tr>
		</thead>
		<tbody>
			{#each data.data as { vehicleId, plateNumber, carParkName, region, status, numberOfDaysToDueDate, mileageLeftInKm, jobs }, index}
				<tr style="height: 77px;">
					<td>
						<span
							class="link link-text"
							on:click={() =>
								navigate(
									`/car-management/details/${vehicleId}`
								)}
							on:keydown={() => {}}
						>
							{plateNumber}
						</span>
					</td>
					<td>
						<span>
							{carParkName}
						</span>
					</td>
					<td>
						<span>
							{region || "-"}
						</span>
					</td>
					<td>
						<span>
							{@html servicingStatus[status] || "-"}
						</span>
					</td>
					<td>{@html checkDueDate(numberOfDaysToDueDate)}</td>
					<td>
						{@html checkMileage(mileageLeftInKm)}
					</td>
					<td class="jobs-tooltip">
						{#if jobs.length > 0}
							<Dropdown
								isOpen={isDropdownOpen === index}
								toggle={() => toggleDropdown(jobs, index)}
							>
								<DropdownToggle tag="div">
									{#if jobs.length === 1 || jobs.length === 2}
										{#each jobs as { jobRefId, jobId }, index}
											<span
												class="link link-text"
												on:keydown={() => {}}
												on:click={() =>
													navigate(
														`/jobs/details/${jobId}/1`
													)}
											>
												{jobRefId}</span
											>{#if index < jobs.length - 1}
												<span>
													{", "}
												</span>
											{/if}
										{/each}
									{:else}
										{#each jobs.slice(0, 2) as { jobId, jobRefId }, index}
											<span class="link link-text">
												{jobRefId}</span
											>{#if index < Math.min(jobs.length, 2) - 1}
												<span>
													{", "}
												</span>
											{/if}
										{/each}
										{#if jobs.length > 2}
											<span>...</span>
										{/if}
									{/if}
								</DropdownToggle>
								<DropdownMenu>
									<div class="jobs-dropdown">
										{#each jobs as job, index}
											<DropdownItem
												on:click={() =>
													navigate(
														`/jobs/details/${job.jobId}/1`
													)}
											>
												<div class="jobs-option">
													{job.jobRefId}
												</div>
											</DropdownItem>
										{/each}
									</div>
								</DropdownMenu>
							</Dropdown>
						{:else}
							<span>-</span>
						{/if}
					</td>
				</tr>
			{/each}
		</tbody>
	</Table>
	<Pagination totalRecord={data.totalCount} />
</LoaderContainer>

<style>
	.jobs-tooltip {
		position: relative;
		cursor: pointer;
	}

	.sort-column {
		display: flex;
		justify-content: space-between;
	}

	.jobs-dropdown {
		width: 200px !important;
	}

	.jobs-option {
		height: 35px;
		display: flex;
		align-items: center;
	}
</style>
